import React from "react";
import moment from "moment";
import "moment/locale/id";

export default function LabRequest({ patient, letter }) {
    return (
        <div>
            <h5 className="text-center">Formulir Permintaan Laboratorium</h5>
            <table className="table table-sm">
                <tbody>
                    <tr>
                        <th>Nama</th>
                        <td>{patient.fullName}</td>
                    </tr>
                    <tr>
                        <th>Tanggal</th>
                        <td>{moment(letter.createdAt).format("dddd, DD-MM-YYYY")}</td>
                    </tr>
                    {letter.onBehalfOf.indexOf("dr.") > -1 && (
                        <tr>
                            <th>Dokter</th>
                            <td>{letter.onBehalfOf}</td>
                        </tr>
                    )}
                    <tr>
                        <th>Diagnosa</th>
                        <td>{letter.diagnosis}</td>
                    </tr>
                    <tr className="table-primary text-center">
                        <th colSpan={2}>Terverifikasi</th>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}
